import { useState } from 'react';
import { useController } from 'react-hook-form';

import ImageUploader from './ImageUploader';

const ImageUploaderComponent = ({
  image = null,
  label,
  name,
  control,
  maxSizeMB,
  recommendedSize,
}) => {
  const [editActive, setEditActive] = useState(false);

  const {
    field: { ref, value, onChange },
  } = useController({
    name,
    control,
  });

  return (
    <>
      <span className="c-user-sidebar__image-label">{label}</span>
      {(image && !editActive) || (value && !editActive) ? (
        <div className="c-user-sidebar__logo-container">
          <div
            style={{
              background: `url(${value?.url || image?.url})`,
            }}
            className="c-user-sidebar__logo"
          />

          <button
            type="button"
            className="c-user-sidebar__edit-button"
            onClick={() => setEditActive(true)}>
            Cambiar
          </button>
        </div>
      ) : (
        <>
          <ImageUploader
            maxSizeMB={maxSizeMB}
            recommendedSize={recommendedSize}
            ref={ref}
            handleChange={(img) => {
              onChange(img);
              setEditActive(false);
            }}
          />
          {editActive && (
            <button
              type="button"
              className="c-user-sidebar__edit-button"
              onClick={() => setEditActive(false)}>
              Cancelar
            </button>
          )}
        </>
      )}
    </>
  );
};

export default ImageUploaderComponent;
